import Styles from './NSNoData.module.css';
import { IBaseComponentProps } from '../props/IBaseComponentProps';

export interface NSNoDataProps extends IBaseComponentProps
{
	lable: string;
}

export function NSNoData(props: NSNoDataProps)
{
	return (
		<div
			id={props.id}
			className={`${Styles.ns_table_no_data} ${props.classList?.join(" ") ?? ""}`}
			style={props.style}
		>
			<img
				src='https://static.namirasoft.com/image/concept/no_data/white.svg'
				alt='No Data'
				width={96}
				height={96} />
			<h4>{props.lable}</h4>
		</div>
	);
}